package com.macrofocus.high_d.axis

enum class BinType {
    Auto, Fixed {
        override fun toString(): String {
            return "Auto"
        }
    },
    AutoSigma, Sigma
}